import Clarity from "@microsoft/clarity";

const PROJECTS = {
  website: "wj6iv1di1a",
  webapp: "wj6jvwafeo",
};

let isInitialized = false;

/* ---------------- DEVICE DETECTION ---------------- */
const getProjectId = () => {
  const isMobile = /Mobi|Android|iPhone/i.test(navigator.userAgent);
  return isMobile ? PROJECTS.webapp : PROJECTS.website;
};

/* ---------------- GET USER ---------------- */
const getUserFromStorage = () => {
  try {
    const user = localStorage.getItem("user");
    return user ? JSON.parse(user) : null;
  } catch {
    return null;
  }
};

/* ---------------- SAFE CLARITY RUNNER ---------------- */
const runClarity = (callback, retry = 0) => {
  if (typeof window !== "undefined" && typeof window.clarity === "function") {
    callback();
  } else if (retry < 10) {
    setTimeout(() => runClarity(callback, retry + 1), 300);
  } else {
    console.warn("Clarity not ready after retries");
  }
};

export const ClarityPlugin = {
  /* ---------------- INIT ---------------- */
  init() {
    if (typeof window === "undefined" || isInitialized) return;

    const projectId = getProjectId();
    Clarity.init(projectId);

    console.log("Clarity initialized:", projectId);

    // ✅ Identify user after script is ready
    runClarity(() => {
      const user = getUserFromStorage();
      if (user) this.identify(user);
    });

    // ✅ AUTO CLICK TRACKING
    document.addEventListener("click", (e) => {
      const target = e.target;
      const el = target.closest("button, a, [data-clarity]");
      if (!el) return;

      let label =
        el.innerText ||
        el.getAttribute("aria-label") ||
        el.getAttribute("data-clarity") ||
        el.id ||
        "";

      label = label
        .trim()
        .replace(/\s+/g, "_")
        .toLowerCase();

      if (!label) return;

      const eventName = "click_" + label;

      runClarity(() => {
        window.clarity("event", eventName);
      });

      if (process.env.NODE_ENV === "development") {
        console.log("🟢 Clarity Click:", eventName, el);
      }
    });

    isInitialized = true;
  },

  /* ---------------- IDENTIFY USER ---------------- */
  identify(user) {
    if (!user) return;

    runClarity(() => {
      window.clarity("identify", String(user.id));

      if (user.email) window.clarity("set", "email", user.email);
      if (user.full_name) window.clarity("set", "name", user.full_name);
      if (user?.plan?.name) window.clarity("set", "plan", user.plan.name);
      if (user.city) window.clarity("set", "city", user.city);
      if (user.living_state) window.clarity("set", "state", user.living_state);

      //   if (user?.nursing_role?.role_title)
      //     window.clarity("set", "role", user.nursing_role.role_title);

      //   if (user?.nursing_experience?.experience_title)
      //     window.clarity(
      //       "set",
      //       "experience",
      //       user.nursing_experience.experience_title,
      //     );
    });
  },

  /* ---------------- CUSTOM EVENT ---------------- */
  event(name) {
    runClarity(() => {
      window.clarity("event", name);
    });
  },

  /* ---------------- PAGE TRACKING ---------------- */
  page(path) {
    runClarity(() => {
      window.clarity("event", "page_" + path);
    });
  },
};
